import config from '../config'
import { checkStatus } from '../utils/fetch'
import { logOut } from '../actions/users'
import { authorizedFetch } from '../utils/auth.js'

export const REQUEST_EVENTS = 'REQUEST_EVENTS'
export const RECEIVE_EVENTS = 'RECEIVE_EVENTS'

export const REQUEST_EVENTS_LINKS = 'REQUEST_EVENTS_LINKS'
export const RECEIVE_EVENTS_LINKS = 'RECEIVE_EVENTS_LINKS'

export const SHOW_ADD_EVENT_FORM = 'SHOW_ADD_EVENT_FORM'
export const CLOSE_ADD_EVENT_FORM = 'CLOSE_ADD_EVENT_FORM'
export const UPDATE_EVENT_FIELD = 'UPDATE_EVENT_FIELD'
export const UPDATE_EVENT = 'UPDATE_EVENT'
export const UPDATE_EVENT_SUCCEDED = 'UPDATE_EVENT_SUCCEDED'
export const DELETE_EVENT = 'DELETE_EVENT'
export const DELETE_EVENT_SUCCEDED = 'DELETE_EVENT_SUCCEDED'
export const CHANGE_IMAGE = 'CHANGE_IMAGE'
export const CANCEL_IMAGE = 'CANCEL_IMAGE'

export const SHOW_ATTENDEES = 'SHOW_ATTENDEES'
export const HIDE_ATTENDEES = 'HIDE_ATTENDEES'

export const SHOW_PAST_EVENTS = 'SHOW_PAST_EVENTS'
export const SHOW_ERROR_EVENTS = 'SHOW_ERROR_EVENTS'
export const UPDATE_EVENTS_FILTER = 'UPDATE_EVENTS_FILTER'

export const SHOW_NOTIFICATION_FORM = 'SHOW_NOTIFICATION_FORM'
export const CLOSE_NOTIFICATION_FORM = 'CLOSE_NOTIFICATION_FORM'
export const UPDATE_NOTIFICATION_FIELD = 'UPDATE_NOTIFICATION_FIELD'
export const UPDATE_REMINDER_FIELD = 'UPDATE_REMINDER_FIELD'
export const UPDATE_NOTIFICATIONS_SUCCEDED = 'UPDATE_NOTIFICATIONS_SUCCEDED'
export const SHOW_SPINNER = 'SHOW_SPINNER'
export const CHANGE_PAGE = 'CHANGE_PAGE_EVENTS'

export const updateFilter = (filter, value) => ({
  type: UPDATE_EVENTS_FILTER,
  filter: filter,
  value: value
})

export const displayError = error => ({
  type: SHOW_ERROR_EVENTS,
  error: error
})

export const showPastEvents = showPastEvents => ({
  type: SHOW_PAST_EVENTS,
  showPastEvents: showPastEvents
})

export const showAttendees = event => dispatch => {
  authorizedFetch(config.api_url + 'events/' + event._id)
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(showAttendeesReady(json)))
    .catch(function(error) {
      dispatch(logOut())
    })
}

export const showAttendeesReady = event => ({
  type: SHOW_ATTENDEES,
  sessions: event.sessions
})

export const hideAttendees = () => ({
  type: HIDE_ATTENDEES
})

export const cancelImage = () => ({
  type: CANCEL_IMAGE
})

export const changeImage = image => ({
  type: CHANGE_IMAGE,
  image: image
})

export const requestEvents = () => ({
  type: REQUEST_EVENTS
})

export const receiveEvents = json => ({
  type: RECEIVE_EVENTS,
  json: json.data
})

export const fetchEvents = (filters, skip, take) => dispatch => {
  var headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  dispatch(requestEvents())
  authorizedFetch(config.api_url + 'events/list', {
    headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ filters, skip, take })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(receiveEvents({ data: json })))
    .catch(function(error) {
      dispatch(logOut())
    })
}

export const requestEventsLinks = () => ({
  type: REQUEST_EVENTS_LINKS
})

export const receiveEventsLinks = json => ({
  type: RECEIVE_EVENTS_LINKS,
  json: json.data
})

export const fetchEventsLinks = () => dispatch => {
  dispatch(requestEvents())
  authorizedFetch(config.api_url + 'events/listEventsLinks')
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(receiveEventsLinks({ data: json })))
    .catch(function(error) {
      dispatch(logOut())
    })
}

export const showNotificationForm = (notification, reminder, event) => ({
  type: SHOW_NOTIFICATION_FORM,
  notification: notification,
  reminder: reminder,
  eventInfo: event
})

export const closeNotificationForm = () => ({
  type: CLOSE_NOTIFICATION_FORM
})

export const updateNotificationField = (name, value) => ({
  type: UPDATE_NOTIFICATION_FIELD,
  name: name,
  value: value
})

export const updateReminderField = (name, value) => ({
  type: UPDATE_REMINDER_FIELD,
  name: name,
  value: value
})

export const updateNotification = (notification, event) => dispatch => {
  var headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'events/notifications/' + event._id, {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ notification: notification, event: event })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(updateNotificationsSucceded(json)))
    .catch(function(error) {
      dispatch(logOut())
    })
}

export const updateNotificationsSucceded = event => ({
  type: UPDATE_NOTIFICATIONS_SUCCEDED,
  event: event
})

export const showUpdateEventForm = event => ({
  type: SHOW_ADD_EVENT_FORM,
  event: event
})

export const closeAddEventForm = () => ({
  type: CLOSE_ADD_EVENT_FORM
})

export const updateField = (name, value) => ({
  type: UPDATE_EVENT_FIELD,
  name: name,
  value: value
})

export const updateEvent = event => dispatch => {
  var headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'events/update', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ event: event })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(updateEventSucceded(json)))
    .catch(function(error) {
      dispatch(logOut())
    })
}

export const updateEventSucceded = event => ({
  type: UPDATE_EVENT_SUCCEDED,
  event: event
})

export const deleteEvent = event => dispatch => {
  var headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'events/delete', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ event: event })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(deleteEventSucceded(json)))
    .catch(function(error) {
      dispatch(logOut())
    })
}

export const deleteEventSucceded = event => ({
  type: DELETE_EVENT_SUCCEDED,
  event: event
})

export const showSpinner = () => ({
  type: SHOW_SPINNER
})

export const changePage = pageNumber => ({
  type: CHANGE_PAGE,
  pageNumber
})



// WEBPACK FOOTER //
// ./src/actions/events.js